import { SITE, PARTNERS } from "@/config/site";

/** Core business entity reused across pages (LodgingBusiness/Resort). */
export function lodgingJsonLd(image: string) {
  return {
    "@context": "https://schema.org",
    "@type": ["LodgingBusiness", "EventVenue"],
    "@id": `${SITE.url}/#business`,
    name: SITE.name,
    description: SITE.description,
    url: SITE.url,
    image,
    email: SITE.email,
    priceRange: "$$$",
    numberOfRooms: 4,
    address: {
      "@type": "PostalAddress",
      addressLocality: "Fallbrook",
      addressRegion: "CA",
      addressCountry: "US",
    },
    areaServed: SITE.serviceAreas.map((name) => ({
      "@type": "City",
      name,
    })),
    amenityFeature: [
      "Air Conditioning",
      "WiFi",
      "Parking",
      "Smart TV",
      "Washer/Dryer",
      "Indoor Fireplace",
      "Full Kitchen",
      "Barbecue Grill",
      "Pool Table",
    ].map((name) => ({ "@type": "LocationFeatureSpecification", name, value: true })),
    sameAs: [PARTNERS.airbnb, PARTNERS.vrbo],
  };
}

export function faqJsonLd(items: { q: string; a: string }[]) {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: items.map(({ q, a }) => ({
      "@type": "Question",
      name: q,
      acceptedAnswer: { "@type": "Answer", text: a },
    })),
  };
}

export function breadcrumbJsonLd(trail: { name: string; path: string }[]) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: trail.map((t, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: t.name,
      item: `${SITE.url}${t.path === "/" ? "" : t.path}`,
    })),
  };
}
